import {makeTrackEvent} from './makeTrackEvent';

export type PanelQuickAddAction =
  | 'Drawer opened'
  | 'Search box blurred'
  | 'Add bulk clicked'
  | 'Add one clicked'
  | 'Multi-metric panels added';
export type PanelQuickAddScope = 'global' | 'section';
export type PanelQuickAddEvent = {
  action: PanelQuickAddAction;
  scope: PanelQuickAddScope;
  location?: string;
  isSearchActive?: boolean;
  numPanelsAdded?: number;
  // multi-metric only
  metricRegex?: string;
  numMetricsMatchedMin?: number;
  numMetricsMatchedMean?: number;
  numMetricsMatchedMax?: number;
  removeAutoPanels?: boolean;
};

export const trackPanelQuickAdd = makeTrackEvent<
  PanelQuickAddEvent,
  {
    action: {
      description: 'what action took place';
    };
    scope: {
      description: 'whether user is adding globally or to a specific section';
      exampleValues: ['global', 'section'];
    };
    location: {
      description: 'where the action was triggered from';
    };
    isSearchActive: {
      description: 'whether a search query is present';
    };
    numPanelsAdded: {
      description: 'the number of panels added';
    };
    metricRegex?: {
      description: '(multi-metric only) the regex used to match metrics';
    };
    numMetricsMatchedMin?: {
      description: '(multi-metric only) the minimum number of metrics matched';
    };
    numMetricsMatchedMean?: {
      description: '(multi-metric only) the mean number of metrics matched';
    };
    numMetricsMatchedMax?: {
      description: '(multi-metric only) the maximum number of metrics matched';
    };
    removeAutoPanels?: {
      description: '(multi-metric only) whether unmodified auto panels were removed';
    };
    _description: 'Tracks events related to panel quick add';
    _location: 'workspaces';
    _motivation: 'new UI added, track usage';
  }
>('Panel quick add');
